/*
 * @Author: yidan.chen
 * @Date: 2025-02-26 10:11:10
 * @Last Modified by: yidan.chen
 * @Last Modified time: 2025-04-24 14:49:19
 */
import { commonServerInstance } from '@/utilities/instances'
export const fetchBEFDetail = async (id: string) => {
  const response = await commonServerInstance.get(
    `/settle/bill/detail?id=${id}`
  )
  return response?.data?.data
}

export const fetchBillOrderList = async (query: {
  page?: string
  per_page?: string
  id: string
}) => {
  const response = await commonServerInstance.get('/settle/bill/orders', {
    params: query
  })
  return response?.data?.data
}

export const fetchBillHistory = async (query: { id: string }) => {
  const response = await commonServerInstance.get('/settle/bill/history', {
    params: query
  })
  return response?.data?.data
}

export const reviewBills = async ({
  id,
  action,
  comment
}: {
  id: string
  action: 'approve' | 'reject'
  comment?: string
  [key: string]: any
}) => {
  const response = await commonServerInstance.post('/settle/bill/review', {
    id,
    action,
    comment
  })
  return response
}

export const uploadBillableStatement = async ({
  file,
  id
}: {
  file: File
  id: string
}) => {
  const formData = new FormData()
  formData.append('file', file)
  formData.append('id', id)

  const response = await commonServerInstance.post(
    '/settle/bill/upload-billable',
    formData
  )
  return response?.data?.data
}

export const confirmBillableStatement = async ({ id }: { id: string }) => {
  const response = await commonServerInstance.post(
    '/settle/bill/confirm-billable',
    { id }
  )
  return response
}

export const getBillHistory = async ({ id }: { id: string }) => {
  const response = await commonServerInstance.get('/settle/bill/history', {
    params: { id }
  })
  return response?.data?.data
}

export const getBillableInfo = async ({
  id
}: {
  id: string
}): Promise<{
  billable_amount: string | number
  billable_count: string | number
  disputed_amount: string | number
  disputed_count: string | number
  total_amount: string | number
  total_count: string | number
}> => {
  const response = await commonServerInstance.get(
    '/settle/bill/billable/info',
    {
      params: { id }
    }
  )
  return response?.data?.data
}

export const getBillableFileList = async ({
  id,
  page,
  per_page
}: {
  id: string
  page: number | string
  per_page: number | string
}): Promise<{
  total: number
  data: Array<{
    file_id: string
    file_name: string
    created_at: string
    status: 'Completed' | 'Processing' | 'Pending Processing'
    billable_count: number | string
    billable_amount: number | string
    file_path: string
  }>
}> => {
  const response = await commonServerInstance.get(
    '/settle/bill/billable/file-list',
    {
      params: { id, per_page, page }
    }
  )
  return response?.data?.data
}

export const uploadBillableFile = async ({
  id,
  file
}: {
  id: string
  file: File
}) => {
  const formData = new FormData()
  formData.append('file', file)
  formData.append('id', id)

  const response = await commonServerInstance.post(
    '/settle/bill/billable/file-upload',
    formData,
    {
      timeout: 0
    }
  )
  return response?.data?.data
}

export const deleteBillableFile = async ({ id }: { id: string }) => {
  const response = await commonServerInstance.post(
    '/settle/bill/billable/file-delete',
    { file_id: id }
  )
  return response?.data?.data
}

export const confirmBillableFile = async ({ id }: { id: string }) => {
  const response = await commonServerInstance.post(
    '/settle/bill/billable/confirm',
    { id }
  )
  return response?.data?.data
}

export const resetBillableFile = async ({ id }: { id: string }) => {
  const response = await commonServerInstance.post(
    '/settle/bill/reset-status',
    { id }
  )
  return response?.data?.data
}

export const refillInvoiceDate = async ({ id }: { id: string }) => {
  const response = await commonServerInstance.post(
    '/settle/bill/backfill-invoice-date',
    { id }
  )
  return response?.data?.data
}

export const splitReturnFee = async ({ id }: { id: string }) => {
  const response = await commonServerInstance.post(
    '/settle/bill/split-return-fee',
    { id }
  )
  return response?.data?.data
}
